<template>
  <div class="lab_test__list">
    <vs-table
      id="table-loading"
      class="vs-con-loading__container"
      stripe
      :sst="true"
      @search="updateSearchQuery"
      @change-page="handleChangePage"
      @sort="handleSort"
      maxHeight="500px"
      :total="FilteredCount"
      search
      :max-items="this.data.length"
      :data="labTests"
    >
      <template slot="header">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ data.page * data.length - (data.length - (FilteredCount && 1)) }}
                  -
                  {{ FilteredCount - data.page * data.length > 0 ? data.page * data.length : FilteredCount }}
                  of {{ FilteredCount }} (filtered from {{ total }} total entries)
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="handleChangeLength(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <div
            @click="$router.push('/lab-test/add')"
            class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New lab Test</span>
          </div>
        </div>
      </template>

      <template slot="thead">
        <vs-th sort-key="lab_test.id">Lab Test Id</vs-th>
        <vs-th sort-key="lab_test.product_name">Strain Name</vs-th>
        <vs-th sort-key="category.category_name">Category</vs-th>
        <vs-th sort-key="batch.batch_name">Batch</vs-th>
        <vs-th>Status</vs-th>
        <vs-th sort-key="lab_test.created_at">Date</vs-th>
        <vs-th>Note</vs-th>
        <vs-th>View</vs-th>
      </template>

      <template slot-scope="{ data }" ref="tableBody">
        <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
          <vs-td>{{ tr.id }}</vs-td>
          <vs-td>{{ tr.product_name }}</vs-td>
          <vs-td>{{ tr.category && tr.category.category_name }}</vs-td>
          <vs-td>{{ tr.batch.batch_name }}</vs-td>
          <vs-td>{{ tr.status }}</vs-td>
          <vs-td>{{ formatDate(tr.created_at) }}</vs-td>
          <vs-td><feather-icon class="cursor-pointer p-2" icon="PlusIcon" @click="addNote(tr)"/></vs-td>
          <vs-td><feather-icon class="cursor-pointer p-2" icon="EyeIcon" @click="viewLabTestPdf(tr.id)"/></vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-pagination v-model="data.page" :total="totalPages" :max="totalPages / data.length > 7 ? 7 : 9" class="mt-8"></vs-pagination>

    <AddNote :is_note_popup_open.sync="is_note_popup_open" :addLabNote="addLabNote" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import AddNote from '@/views/lab-tests/components/AddNote.vue'

export default {
  name: 'LabTestTable',

  components: {
    AddNote
  },

  props: {
    labTests: Array,
    data: {
      order: Array,
      length: Number,
      page: Number,
      search: String,
      pending: String
    }
  },

  data() {
    return {
      is_note_popup_open: false,
      addLabNote: {
        labTestId: null,
        note: ''
      }
    }
  },
  mixins: [dateMixins],
  computed: {
    ...mapState('lab_test', ['FilteredCount', 'total']),

    // set total pages for pagination
    totalPages() {
      return Math.ceil(this.FilteredCount / this.data.length)
    }
  },
  methods: {
    // search record
    updateSearchQuery(search) {
      this.$emit('update:data', { ...this.data, page: 1, search })
    },

    // sort the data in table
    handleSort(key, active) {
      if (!key) return

      this.$emit('update:data', { ...this.data, page: 1, order: [key, active === 'desc' ? 'DESC' : 'ASC'] })
    },

    // handle change page
    handleChangePage(page) {
      this.$emit('update:data', { ...this.data, page })
    },

    // handle change limit - records per page
    handleChangeLength(length) {
      this.$emit('update:data', { ...this.data, page: 1, length })
    },

    viewLabTestPdf(id) {
      const routeData = this.$router.resolve({ name: 'lab-test-view-pdf', params: { id } })
      window.open(routeData.href, '_blank')
    },

    //add note
    addNote(data) {
      this.is_note_popup_open = true
      this.addLabNote.labTestId = data.id
      this.addLabNote.note = data.note
    }
  },

  // update page
  watch: {
    'data.page'() {
      this.$emit('update:data', { ...this.data })
    }
  }
}
</script>

<style></style>
